import { Theme, createStyles } from "@material-ui/core";
import Switch from "@material-ui/core/Switch";
import { withStyles } from "@material-ui/styles";
import { getCurrentGlobalContext } from "qpr-base/context/AppCtxProvider";

const AntSwitch = withStyles((theme: Theme) =>
  createStyles({
    root: {
      width: 50,
      height: 20,
      padding: 0,
      display: "flex",
      transform: getCurrentGlobalContext().rtl ? "" : "scaleX(-1)",
    },
    switchBase: {
      padding: 2,
      color: "rgb(0,100,216)",
      "&$checked": {
        transform: "translateX(32px) ",
        color: "rgb(0,100,216)",
        "& + $track": {
          opacity: 1,
          backgroundColor: "transparent",
          borderColor: "#00000080",
        },
      },
    },
    thumb: {
      width: 14,
      height: 14,
      transform: "translateY(1px) ",
      boxShadow: "none",
    },
    track: {
      border: `1px solid #00000080`,
      borderRadius: 40,
      opacity: 1,
      backgroundColor: "transparent",
    },
    checked: {},
  })
)(Switch);

export default AntSwitch;
